let passes = [];
let fileSize;
let fileExtension;

function validateImage(extension = '') {
    if (extension.length > 0) {
        return fileExtension === `image/${extension}`;
    }
    return !!fileExtension.match('image/*');
}

function validateApplication(extension = '') {
    if (extension.length > 0) {
        return fileExtension === `application/${extension}`;
    }
    return !!fileExtension.match('application/*');
}

function validateText(extension = '') {
    if (extension.length > 0) {
        return fileExtension === `text/${extension}`;
    }
    return !!fileExtension.match('text/*');
}

function validateMaxSize(value) {
    const kilobytes = parseInt(fileSize, 10) / 1000;

    return Math.round(kilobytes) <= parseInt(value, 10);
}

function validateMime(value) {
    const mimeType = value.split(',');

    const mimeTypePasses = [];

    function validate(type, extension) {
        switch (type) {
            case 'image':
                return validateImage(extension);
            case 'application':
                return validateApplication(extension);
            case 'text':
                return validateText(extension);
        }
    }

    if (mimeType.length > 1) {
        mimeType.forEach((mime) => {
            let extension = '';
            let type;
            let passes;
            if (mime.includes('/')) {
                const splitMime = mime.split('/');
                type = splitMime[0];
                extension = splitMime[1];

                passes = validate(type, extension);
                mimeTypePasses.push(passes);
            } else {
                passes = validate(mime, extension);
                mimeTypePasses.push(passes);
            }
        });

        return mimeTypePasses.filter((pass) => pass).length > 0;
    }

    let extension = '';
    if (value.includes('/')) {
        const splitValue = value.split('/')
        value     = splitValue[0];
        extension = splitValue[1];

        if (extension === '*') {
            extension = ''
        }
    }
    const passes = validate(value, extension);
    mimeTypePasses.push(passes);

    return mimeTypePasses.filter((pass) => pass).length > 0;
}

/*
  Validate file size and mime_type
  Examples:
    - mime:pdf,image/png,image|max:6144
    - mime:image,pdf - All types of images
    - max:10000
    - mime:application/pdf,image/png,image/jpeg - Only pdf, png and jpeg extension
 */
function make(rule, file) {
    passes = [];
    fileSize = file.size;
    fileExtension = file.type;

    const rules = rule.split('|');

    rules.forEach((splitRule) => {
        if (splitRule.includes(':')) {
            const split = splitRule.split(':');
            const type = split[0];
            const value = split[1];

            let pass;
            if (type === 'max') {
                pass = validateMaxSize(value);
            }
            if (type === 'mime') {
                pass = validateMime(value);
            }

            passes.push({
                type,
                pass,
                value,
            });
        }
    });

    return passes;
}

export { make };
